import { reduce } from 'lodash';

export function slugify(text) {
  return text
    .toString() // Cast to string
    .toLowerCase() // Convert the string to lowercase letters
    .normalize('NFD') // The normalize() method returns the Unicode Normalization Form of a given string.
    .trim() // Remove whitespace from both sides of a string
    .replace(/\s+/g, '_') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-'); // Replace multiple - with single -
}

export function findKeys(id, options, ignoreInitialOption = false) {
  let result = ignoreInitialOption ? [] : [id];

  function go(value) {
    result.push(value);
    hash[value] && hash[value].forEach(go);
  }

  let hash = reduce(
    options,
    (result, value, key) => {
      result[value.parent_id] = result[value.parent_id] || [];
      result[value.parent_id].push(value.id);

      return result;
    },
    {},
  );

  hash[id] && hash[id].forEach(go);
  return result;
}

export function flatten(option, options, ignoreInitialOption = false) {
  let result = ignoreInitialOption ? [] : [option];

  function go(value) {
    result.push(value);
    hash[value.id] && hash[value.id].forEach(go);
  }

  let hash = reduce(
    options,
    (result, value, key) => {
      result[value.parent_id] = result[value.parent_id] || [];
      result[value.parent_id].push(value);

      return result;
    },
    {},
  );

  hash[option.id] && hash[option.id].forEach(go);
  return result;
}
